export default {
    creationForm: 'PROFILE_CREATION_FORM',
    allFamiliesSelectable: 'ALL_FAMILIES_SELECTABLE',
    qrcodeSetup: 'QRCODE_SETUP',
    selectedCategories: 'SELECTED_CATEGORIES',
    selectedBackground: 'SELECTED_BACKGROUND',
    priceConfiguration: 'PRICE_CONFIGURATION',
};
